import { CircularProgress, Grid, Typography } from '@material-ui/core'
import React from 'react'

import useMediaQuery from '../../../../hooks/useMediaQuery'
import useUserCategory from '../../../../hooks/useUserCategory'
import { StyledFunctionComponent } from '../../../types'
import * as Styled from './styled'

export const getRewardsText = ({
  isMobile,
  isPractitioner,
}: {
  isMobile: boolean
  isPractitioner: boolean
}): { rewardsHeader: string; rewardsLabel: string } =>
  isPractitioner && isMobile
    ? { rewardsHeader: 'APPLY REWARDS', rewardsLabel: 'Rewards Balance: ' }
    : isPractitioner
      ? { rewardsHeader: 'PAY WITH REWARDS AND CREDIT', rewardsLabel: 'Rewards & Credit Balance: ' }
      : isMobile
        ? { rewardsHeader: 'APPLY STORE CREDIT', rewardsLabel: 'Store Credit Balance: ' }
        : { rewardsHeader: 'PAY WITH STORE CREDIT', rewardsLabel: 'Store Credit Balance: ' }

export const ApplyRewardsSkeleton: StyledFunctionComponent = ({ className }) => {
  const isMobile = useMediaQuery({ maxWidth: '425px' })
  const { userCategory } = useUserCategory()
  const isPractitioner = userCategory === 'practitioner'
  const { rewardsHeader, rewardsLabel } = getRewardsText({ isMobile, isPractitioner })
  return (
    <Styled.Container
      className={className}
      alignItems="center"
      justify="center"
      container
      item
      xs={12}
    >
      <Grid item xs={12}>
        <Styled.Header>
          <Typography variant="h5">{rewardsHeader}</Typography>
        </Styled.Header>
        <Styled.TotalBalance>
          <Styled.TotalBalanceText>
            <Styled.RewardsIcon />
            {rewardsLabel}
            <Styled.TotalBalanceAmount>
              <CircularProgress size={14} />
            </Styled.TotalBalanceAmount>
          </Styled.TotalBalanceText>
        </Styled.TotalBalance>
      </Grid>
    </Styled.Container>
  )
}
